export class Authathenticate {
  userAuthenticate: boolean = false;

}
